/**
 * Returns Tailwind classes for custom scrollbar styling
 */
export const getScrollbarClasses = () => {
  return [
    // Base scrolling behavior
    "overflow-y-auto",
    "overflow-x-hidden",
    "pr-2", // padding-right for scrollbar space

    // Firefox scrollbar styling
    "[scrollbar-width:thin]",
    "[scrollbar-color:var(--color-scrollbar-thumb)_var(--color-scrollbar-track)]",

    // Webkit scrollbar styling
    "[&::-webkit-scrollbar]:w-3", // 12px width
    "[&::-webkit-scrollbar]:bg-[var(--color-scrollbar-track)]",
    "[&::-webkit-scrollbar]:rounded",

    // Webkit scrollbar track
    "[&::-webkit-scrollbar-track]:bg-[var(--color-scrollbar-track)]",
    "[&::-webkit-scrollbar-track]:rounded",
    "[&::-webkit-scrollbar-track]:my-1", // 4px margin

    // Webkit scrollbar thumb
    "[&::-webkit-scrollbar-thumb]:bg-[var(--color-scrollbar-thumb)]",
    "[&::-webkit-scrollbar-thumb]:rounded",
    "[&::-webkit-scrollbar-thumb]:border-2",
    "[&::-webkit-scrollbar-thumb]:border-solid",
    "[&::-webkit-scrollbar-thumb]:border-transparent",
    "[&::-webkit-scrollbar-thumb]:bg-clip-padding",
    "[&::-webkit-scrollbar-thumb]:min-h-[54px]",

    // Webkit scrollbar thumb hover
    "[&::-webkit-scrollbar-thumb:hover]:bg-[var(--color-scrollbar-thumb)]",
    "[&::-webkit-scrollbar-thumb:hover]:opacity-100",

    // Hide horizontal scrollbar
    "[&::-webkit-scrollbar:horizontal]:hidden",

    // Webkit scrollbar corner
    "[&::-webkit-scrollbar-corner]:bg-transparent",

    // Additional scrollbar properties
    "[scrollbar-gutter:stable]",
  ].join(" ");
};

/**
 * Returns a string of Tailwind classes for scrollbar styling
 * Usage: className={cn("your-classes", getScrollbarClasses())}
 */
export const scrollbarClasses = getScrollbarClasses();
